import LedgerPage from "@/components/LedgerPage";
export default function Revenue() { return <LedgerPage type="revenue" />; }
